import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36.03 44.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.89 22.25c2.37-3.32 5.11-2.66 8.35-2.29-.86-.92-1.28-2.07-1.28-3.32 0-2.86 2.37-5.18 5.31-5.18 6.12 0 5.36 6.93 2.71 6.93-.6 0-1.07-.42-1.2-.91-.11-.41 0-.89-.15-1.28-.2-.54-.75-.94-1.36-.94-.4 0-.75.16-1.01.41-.82.79-.31 2.39.23 3.2.75 1.13 2.06 1.86 3.57 1.84h.25c4.2-.48 5.43-4.05 4.37-7.29-.46-1.41-2.08-3.48-3.9-4.35 3.35-1.94 4.38-6.41 4.26-9.06L0 22.25 36.02 44.5c.12-2.65-.91-7.13-4.26-9.06 1.82-.87 3.43-2.94 3.9-4.35 1.07-3.24-.17-6.81-4.37-7.29h-.25c-1.51-.02-2.82.71-3.57 1.83-.54.81-1.05 2.4-.23 3.2.26.25.62.41 1.01.41.61 0 1.16-.4 1.36-.94.14-.39.04-.87.15-1.28.13-.5.61-.91 1.2-.91 2.65 0 3.41 6.93-2.71 6.93-2.93 0-5.31-2.32-5.31-5.18 0-1.24.42-2.4 1.28-3.32-3.24.37-5.98 1.04-8.35-2.29",
      style: {"fill":"#9b804d"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "KC-logo"}) } }